import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/qr-code',
  component: mainComponent,
  title: 'QR Code',
  children: [{
      path: '/',
      name: 'qr-code-generate',
      component: () => import('@/views/qr-code/GenerateQrCode.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'QR Code', active: true },
        ],
        pageTitle: 'QR Code',
        rule: 'editor'
      },
    },
  ],
}, ];